import {request} from '@/utils/request'


export default {
    namespaced: true,
    state: {
        isTyxy: false,
        productNum:10
    },
    getters: {


    },
    mutations: {
        tyxy(state){
             state.isTyxy = true
        }
    },
    actions: {
        // 注册
        async signup(context, data) {
            let res
            await request('POST', 'signup', data)
                .then(json => {
                    res = json
                })
            return res
        },
        async sendsms(context, data) {

            let res
            await request('POST', 'captcha', data)
                .then(json => {
                    res = json
                })
            return res
        },
    }
}
